import { useCallback } from "react";

import type { OptionList } from "@/lib/gql/__generated__/graphql";

import type { DnDResultItem } from "@/hooks/use-dnd";
import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info/_hooks/use-toast";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { OptionListUpdate_OptionListPage_Mutation } from "../repository/mutation/update-option-list/mutation";

type Props = {
	hotelID: string;
	dndItemList: Array<DnDResultItem<OptionList["options"][number]>>;
};

export const useSortOptionList = ({ hotelID, dndItemList }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc: updateOptionList } = useCustomMutation(OptionListUpdate_OptionListPage_Mutation);

	const onSaveSort = useCallback(async () => {
		showLoadingScreenCallback();

		const { errors } = await updateOptionList({
			variables: {
				input: {
					hotelID,
					options: dndItemList.map((result) => result.value.optionID),
				},
			},
		}).finally(hideLoadingScreenCallback);

		if (!errors) {
			notifyUserEventInfo({
				title: "オプションの並び替えを保存しました",
			});
		}
	}, [dndItemList, hideLoadingScreenCallback, hotelID, showLoadingScreenCallback, updateOptionList]);

	return { onSaveSort };
};
